import React from "react";
import classNames from "classnames";
import { Link } from "gatsby";

import styles from "./CreditsFooter.module.scss";

interface CreditsFooterProps {
  className?: string;
}

const CreditsFooter: React.FC<CreditsFooterProps> = ({ className }) => {
  return (
    <footer className={classNames(styles.footer, className)}>
      <p>
        Creative Elephant was created by{" "}
        <a
          href="https://www.laurablight.co.uk/"
          target="_blank"
          rel="noreferrer noopener"
        >
          Laura Blight
        </a>
        , <b>Maria Garreaud</b>, <b>Emma Giaretto</b> & <b>Gill Henderson</b> at{" "}
        <a
          href="https://www.arts.ac.uk/colleges/london-college-of-communication"
          target="_blank"
          rel="noreferrer noopener"
        >
          London College of Communication
        </a>
      </p>
      <p>
        Design by{" "}
        <a
          href="http://www.peter-roden.com/"
          target="_blank"
          rel="noreferrer noopener"
        >
          Peter Roden
        </a>
        <br />
        Development by{" "}
        <a href="https://jthaw.me/" target="_blank" rel="noreferrer noopener">
          Jonny Thaw
        </a>
      </p>
      <p>
        <a
          target="_blank"
          rel="noreferrer noopener"
          href="https://www.arts.ac.uk/privacy-information"
        >
          Privacy Policy
        </a>
      </p>
    </footer>
  );
};

export { CreditsFooter };
